import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import 'ion-rangeslider/css/ion.rangeSlider.css'; // Import ionRangeSlider CSS
import 'ion-rangeslider/js/ion.rangeSlider.min.js'; // Import ionRangeSlider JS

const loadScript = src => {
  return new Promise((resolve, reject) => {
    // Check if the script is already present
    const existingScript = document.querySelector(`script[src="${src}"]`);
    if (existingScript) {
      console.log(`Script ${src} already loaded`);
      return resolve();
    }

    // Create a new script element if not already loaded
    const script = document.createElement('script');
    script.src = src;
    script.async = false; // Load asynchronously
    script.onload = () => {
      console.log(`Script ${src} loaded successfully`);
      resolve();
    };
    script.onerror = error => {
      console.error(`Failed to load script ${src}`, error);
      reject(error);
    };
    document.body.appendChild(script);
  });
};

export default function MainContent() {
  const location = useLocation(); // Get the current location object

  useEffect(() => {
    const loadAllScripts = async () => {
      try {
        await loadScript('/corefiles/plugins/jquery-steps/jquery.steps.js');
        await loadScript('/corefiles/plugins/ion-rangeslider/js/ion.rangeSlider.min.js');
        await loadScript('/vendors/scripts/range-slider-setting.js');
        await loadScript('/vendors/scripts/steps-setting.js');
        await loadScript('/corefiles/plugins/jquery-asColor/dist/jquery-asColor.js');
        await loadScript('/corefiles/plugins/jquery-asGradient/dist/jquery-asGradient.js');

        await loadScript('/corefiles/plugins/jquery-asColorPicker/jquery-asColorPicker.js');
        await loadScript('/vendors/scripts/colorpicker.js');
        await loadScript('/aiform.js');
      } catch (error) {
        console.error('Failed to load one or more scripts', error);
      }
    };

    loadAllScripts();
  }, [location]);

  return (
    <div className="main-container">
      <div className="pd-ltr-20 xs-pd-20-10">
        <div className="min-height-200px">
          <div className="pd-20 card-box mb-30">
            <div className="clearfix">
              <h4 className="text-blue h4" id="client_heading">
                AI Setting
              </h4>
            </div>
            <div className="wizard-content dashboard-container">
              <form className="tab-wizard wizard-circle wizard vertical" id="ai_human_settings">
                <h5>Avatar & LLM</h5>
                <section className="">
                  {/* Sub section */}
                  <div className="menu-card-ai">
                    {/* API key combobox */}
                    {/* Heygen API keys */}
                    <div className="row">
                      <h5 style={{ marginBottom: '1rem' }}>Heygen API Key</h5>
                      <div className="col-md-6">
                        <div className="form-group position-relative">
                          <label>Select from Assigned HeyGen API Keys :</label>
                          <select
                            id="heygen_select"
                            className="form-control mb-2"
                            style={{ height: '56px' }}
                          >
                            <option value="" disabled selected>
                              -- Select assigned key --
                            </option>
                          </select>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group position-relative">
                          <label>Type your own HeyGen API Key :</label>
                          <input
                            type="text"
                            id="heygen_custom"
                            className="form-control mb-2"
                            placeholder="Enter your own Heygen key"
                          />
                          <input type="hidden" id="heygen_api_key" name="heygen_api_key" />

                          <input
                            type="hidden"
                            id="heygen_enable_high_quality"
                            name="heygen_enable_high_quality"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Avatar */}
                    <div className="row">
                      <h5 style={{ marginBottom: '1rem' }}>Avatar Key</h5>
                      <div className="col-md-6">
                        <div className="form-group position-relative">
                          <label>Select from Assigned Avatar Keys:</label>
                          <div
                            style={{
                              display: 'flex',
                              gap: '10px',
                              alignItems: 'flex-end',
                              flexWrap: 'wrap',
                            }}
                          >
                            <select
                              id="avtar_select"
                              className="form-control"
                              style={{ height: '56px', flex: '1' }}
                            >
                              <option value="" disabled selected>
                                -- Select assigned key --
                              </option>
                            </select>

                            <button
                              type="button"
                              id="avatarPreviewBtn"
                              className="btn btn-info"
                              style={{
                                height: '56px',
                                // minWidth: '120px',
                                display: 'none',
                              }}
                              title="Preview selected avatar"
                            >
                              <i className="bi bi-eye"></i>
                            </button>

                            <button

                              type="button"

                              id="avatarVideoPreviewBtn"

                              className="btn btn-info"

                              style={{ height: '56px', display: 'none' }}

                              title="Preview avatar video"

                            >

                              <i className="bi bi-play-circle"></i>

                            </button>

                          </div>
                        </div>
                      </div>

                      {/* Custom Looping Video Checkbox */}



                      <div className="col-md-6">
                        <div className="form-group position-relative">
                          <label>Type your own Avatar Key:</label>
                          <input
                            type="text"
                            id="avtar_custom"
                            className="form-control"
                            style={{ height: '56px' }}
                            placeholder="Enter your own Avatar key"
                          />
                          <input type="hidden" id="avtar_key" name="avtar_key" />
                        </div>
                      </div>
                    </div>

                    <div className="row">

                      <div className="col-md-12">

                        <div className="form-group custom-control custom-checkbox">

                          <input

                            type="checkbox"

                            className="custom-control-input"

                            id="custom_looping_video"

                            name="custom_looping_video"

                          />

                          <label className="custom-control-label" htmlFor="custom_looping_video">

                            Use custom looping video instead of avatar's default video

                          </label>

                        </div>

                      </div>

                    </div>



                    {/* Video Upload Section (initially hidden) */}

                    <div id="videoUploadSection" style={{ display: 'none', marginBottom: '24px' }}>

                      <div className="row">

                        <div className="col-md-12">

                          <div>

                            <h5>Upload Looping video</h5>



                            <div

                              style={{ display: 'flex', alignItems: 'center', margin: '12px 0px' }}

                            >

                              <input type="file" id="fileInput" style={{ padding: '12px' }} />

                              <button type="button" id="uploadBtn" style={{ marginLeft: '10px' }}>

                                Upload

                              </button>

                            </div>



                            <div

                              id="progressContainer"

                              style={{ marginTop: '10px', display: 'none' }}

                            >

                              <progress

                                id="progressBar"

                                value="0"

                                max="100"

                                style={{ width: '100%' }}

                              ></progress>

                              <p id="progressText">0% uploaded</p>

                            </div>

                            <div

                              id="uploadedFileContainer"

                              style={{ marginTop: '10px', display: 'block' }}

                            >

                              <h5>Uploaded File:</h5>

                              <a

                                id="uploadedFileLink"

                                href="#"

                                target="_blank"

                                style={{ fontWeight: 'bold' }}

                              ></a>

                            </div>

                            <input type="hidden" id="looping_video_url" />

                          </div>

                        </div>

                      </div>

                    </div>

                    {/* <!-- Voice --> */}
                    <div className="row">
                      <h5 style={{ marginBottom: '1rem' }}>Voice Key</h5>
                      <div className="col-md-6">
                        <div className="form-group position-relative">
                          <label>Select from Assigned Voice Keys:</label>
                          <div
                            style={{
                              display: 'flex',
                              gap: '10px',
                              alignItems: 'flex-end',
                              flexWrap: 'wrap',
                            }}
                          >
                            <select
                              id="voice_select"
                              className="form-control"
                              style={{ height: '56px', flex: '1' }}
                            >
                              <option value="" disabled selected>
                                -- Select assigned key --
                              </option>
                            </select>

                            <button
                              type="button"
                              id="voicePreviewBtn"
                              className="btn btn-info"
                              style={{
                                height: '56px',
                                // minWidth: '120px',
                                display: 'none',
                              }}
                              title="Preview selected voice"
                            >
                              <i className="bi bi-volume-up"></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group position-relative">
                          <label>Type your own Voice Key:</label>
                          <input
                            type="text"
                            id="voice_custom"
                            className="form-control"
                            style={{ height: '56px' }}
                            placeholder="Enter your own Voice key"
                          />
                          <input type="hidden" id="voice_key" name="voice_key" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Avatar Voice Speed (0.5 - 1.5):</label>
                          <input
                            type="number"
                            className="form-control"
                            name="voice_rate"
                            id="voice_rate"
                          // value={aiFormData.voice_rate || ''}
                          // onChange={(e) => setAiFormData({ ...aiFormData, voice_rate: e.target.value })}
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Avatar Emotion:</label>
                          <select
                            id="avtar_emotion"
                            name="avtar_emotion"
                            className="form-control"
                            style={{ height: '56px' }}
                          >
                            <option value="">Select Emotion</option>
                            <option value="Excited">Excited</option>
                            <option value="Serious">Serious</option>
                            <option value="Friendly">Friendly</option>
                            <option value="Soothing">Soothing</option>
                            <option value="Broadcaster">Broadcaster</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    {/* Multiple Api keys dropdown */}

                    <div className="row">
                      {/* <div className="col-md-6">
                        <div className="form-group">
                          <label>Avatar Emotion:</label>
                          <select
                            id="avtar_emotion"
                            name="avtar_emotion"
                            className="form-control"
                            style={{ height: "56px" }}
                          >
                            <option value="">Select Emotion</option>
                            <option value="Excited">Excited</option>
                            <option value="Serious">Serious</option>
                            <option value="Friendly">Friendly</option>
                            <option value="Soothing">Soothing</option>
                            <option value="Broadcaster">Broadcaster</option>
                          </select>
                        </div>
                      </div> */}

                      <div className="col-md-6" style={{display: 'none'}}>
                        <div className="form-group custom-control custom-checkbox" style={{ marginTop: '35px' }}>
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="useNewerHeyGenSDK"
                            name="useNewerHeyGenSDK"
                          />
                          <label className="custom-control-label" htmlFor="useNewerHeyGenSDK">
                            Use Newer HeyGen SDK Version
                          </label>
                          <small className="form-text text-muted">
                            Enable this to use the latest HeyGen SDK with improved features
                          </small>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group" style={{ display: 'none' }}>
                          <label htmlFor="loop_reset_time">
                            Enter a time to reset looping video (minutes)
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="loop_reset_time"
                            name="loop_reset_time"
                          />
                        </div>
                      </div>


                    </div>

                    {/* <div className="row">
                      <div className="col-md-12">
                        <div>
                          <h4>Upload Looping video</h4>

                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              margin: '12px 0px',
                            }}
                          >
                            <input type="file" id="fileInput" style={{ padding: '12px' }} />
                            <button type="button" id="uploadBtn" style={{ marginLeft: '10px' }}>
                              Upload
                            </button>
                          </div>

                          <div
                            id="progressContainer"
                            style={{ marginTop: '10px', display: 'none' }}
                          >
                            <progress
                              id="progressBar"
                              value="0"
                              max="100"
                              style={{ width: '100%' }}
                            ></progress>
                            <p id="progressText">0% uploaded</p>
                          </div>
                          <div
                            id="uploadedFileContainer"
                            style={{ marginTop: '10px', display: 'block' }}
                          >
                            <h3>Uploaded File:</h3>
                            <a
                              id="uploadedFileLink"
                              href="#"
                              target="_blank"
                              style={{ fontWeight: 'bold' }}
                            ></a>
                          </div>
                          <input type="hidden" id="looping_video_url" />
                        </div>
                      </div>
                    </div> */}
                  </div>

                  {/*-------------------------------LLM Options ------------------------------- */}
                  <div className="menu-card-ai" id="llm-container">
                    <div className="row">
                      <h2 style={{ marginBottom: '10px' }}>LLM</h2>

                      <div className="col-md-6">
                        {' '}
                        <div className="form-group">
                          <label htmlFor="llm_option">Select LLM:</label>
                          <select
                            id="llm_option"
                            name="llm_option"
                            className="form-control"
                          ></select>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12" id="motiveFields" style={{ display: 'none' }}>

                    </div>

                    <div className="col-md-12" id="motive" style={{ display: 'none' }}> <div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Organization:</label>
                            <input
                              type="text"
                              className="form-control"
                              id="motive_organization"
                              name="motive_organization"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Space:</label>
                            <input
                              type="text"
                              className="form-control"
                              id="motive_space"
                              name="motive_space"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Agent:</label>
                            <input
                              type="text"
                              className="form-control"
                              id="motive_agent"
                              name="motive_agent"
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Deployment:</label>
                            <input
                              type="text"
                              className="form-control"
                              id="motive_deployment"
                              name="motive_deployment"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Breaer Token:</label>
                            <input
                              type="text"
                              className="form-control"
                              id="motivetoken"
                              name="motivetoken"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Function:</label>
                            <input
                              type="text"
                              className="form-control"
                              id="motive_function"
                              name="motive_function"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Knowledge:</label>
                            <input
                              type="text"
                              className="form-control"
                              id="motive_knowledge"
                              name="motive_knowledge"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Temprature:</label>
                            <input
                              type="number"
                              className="form-control"
                              id="motive_temprature"
                              name="motive_temprature"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Motive API Base Url:</label>
                            <input
                              type="text"
                              className="form-control"
                              id="motive_baseurl"
                              name="motive_baseurl"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Customize no found text:</label>
                            <input
                              type="text"
                              className="form-control"
                              id="motive_outputtext"
                              name="motive_outputtext"
                            />
                          </div>
                        </div>

                        <div className="text-center mt-4">
                          <button
                            type="button"
                            className="btn btn-primary btn-lg"
                            id="submitBtnmotive"
                          >
                            Run Motive Output Text Customization API
                          </button>
                        </div>
                        <div id="resultContainer" className="result-container"></div>
                      </div>
                    </div>

                      <div
                        id="trainingSection"
                        className="training-status"
                        style={{ display: 'none' }}
                      >
                        <div className="alert alert-info">
                          <h6>
                            <i className="bi bi-play-circle"></i> Training Available
                          </h6>
                          <p>Configuration updated successfully. Click below to start training.</p>
                          <button
                            type="button"
                            className="btn btn-success btn-sm"
                            id="startTrainingBtn"
                          >
                            <span
                              className="training-spinner spinner-border spinner-border-sm me-2"
                              role="status"
                              style={{ display: 'none' }}
                            ></span>
                            Start Training
                          </button>
                        </div>
                      </div></div>

                    <div>
                      <input
                        type="text"
                        id="motive_config_id"
                        name="motive_config_id"
                        style={{ display: 'none' }}
                      />
                    </div>


                    <div className="row" id="openaiFields" style={{ display: 'none' }}>
                      {/* Open API Multiple keys */}
                      {/* <!-- OpenAI --> */}
                      <div className="row">
                        <h5 style={{ marginBottom: '1rem' }}>OpenAI API Key</h5>
                        <div className="col-md-6">
                          <div className="form-group position-relative">
                            <label>Select from Assigned OpenAI Keys :</label>
                            <select
                              id="openai_select"
                              className="form-control mb-2"
                              style={{ height: '56px' }}
                            >
                              <option value="" disabled selected>
                                -- Select assigned key --
                              </option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group position-relative">
                            <label>Type your own OpenAI Key :</label>
                            <input
                              type="text"
                              id="openai_custom"
                              className="form-control mb-2"
                              placeholder="Enter your own OpenAI key"
                            />
                            <input type="hidden" id="open_api_key" name="open_api_key" />
                          </div>
                        </div>
                      </div>

                      <h2 style={{ marginBottom: '10px' }}>LLM Prompt</h2>

                      <div className="col-md-12">
                        <div className="form-group">
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <label style={{ marginBottom: 0, fontSize: "20px" }}>Persona:</label>
                            <div>
                              <div className="custom-control custom-checkbox" style={{ display: 'inline-flex', alignItems: 'center' }}>
                                <input type="checkbox" className="custom-control-input" id="persona_rtl" name="persona_rtl" />
                                <label className="custom-control-label" htmlFor="persona_rtl" style={{ marginLeft: '8px' }}>Right to left</label>
                              </div>
                            </div>
                          </div>
                          <textarea
                            id="persona"
                            className="form-control"
                            name="persona"
                            rows="4"
                            cols="50"
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <label style={{ marginBottom: 0, fontSize: "20px" }}>Knowledge Base:</label>
                            <div>
                              <div className="custom-control custom-checkbox" style={{ display: 'inline-flex', alignItems: 'center' }}>
                                <input type="checkbox" className="custom-control-input" id="knowledgeBase_rtl" name="knowledgeBase_rtl" />
                                <label className="custom-control-label" htmlFor="knowledgeBase_rtl" style={{ marginLeft: '8px' }}>Right to left</label>
                              </div>
                            </div>
                          </div>
                          <textarea
                            id="knowledgeBase"
                            className="form-control"
                            name="knowledgeBase"
                            rows="4"
                            cols="50"
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <label style={{ marginBottom: 0, fontSize: "20px" }}>Instructions:</label>
                            <div>
                              <div className="custom-control custom-checkbox" style={{ display: 'inline-flex', alignItems: 'center' }}>
                                <input type="checkbox" className="custom-control-input" id="instructions_rtl" name="instructions_rtl" />
                                <label className="custom-control-label" htmlFor="instructions_rtl" style={{ marginLeft: '8px' }}>Right to left</label>
                              </div>
                            </div>
                          </div>
                          <textarea
                            id="instructions"
                            className="form-control"
                            name="instructions"
                            rows="4"
                            cols="50"
                          ></textarea>
                        </div>

                        <textarea
                          id="modify_response_text"
                          className="form-control"
                          name="modify_response_text"
                          rows="4"
                          cols="50"
                          style={{ display: 'none' }}
                        ></textarea>
                      </div>
                    </div>

                    <div className="row"></div>
                  </div>

                  <div className="menu-card-ai">
                    <div className="row">
                      <h2 style={{ marginBottom: '20px' }}>System Settings</h2>
                      <div className="col-md-6">
                        <div className="form-group select_target_mm_sec">
                          <label htmlFor="select_target_mm">Select Language:</label>
                          <select
                            id="select_target_mm"
                            name="tl"
                            multiple="multiple"
                            className="form-control"
                            style={{ width: '100%' }}
                          >
                            <option value="af">Afrikaans</option>
                            <option value="sq">Albanian</option>
                            <option value="am">Amharic</option>
                            <option value="ar">Arabic</option>
                            <option value="hy">Armenian</option>
                            <option value="az">Azerbaijani</option>
                            <option value="bjs">Bajan</option>
                            <option value="rm">Balkan Gipsy</option>
                            <option value="eu">Basque</option>
                            <option value="bem">Bemba</option>
                            <option value="bn">Bengali</option>
                            <option value="be">Bielarus</option>
                            <option value="bi">Bislama</option>
                            <option value="bs">Bosnian</option>
                            <option value="br">Breton</option>
                            <option value="bg">Bulgarian</option>
                            <option value="my">Burmese</option>
                            <option value="ca">Catalan</option>
                            <option value="ceb">Cebuano</option>
                            <option value="ch">Chamorro</option>
                            <option value="zh">Chinese (Simplified)</option>
                            <option value="zh">Chinese Traditional</option>
                            <option value="zdj">Comorian (Ngazidja)</option>
                            <option value="cop">Coptic</option>
                            <option value="aig">Creole English (Antigua and Barbuda)</option>
                            <option value="bah">Creole English (Bahamas)</option>
                            <option value="gcl">Creole English (Grenadian)</option>
                            <option value="gyn">Creole English (Guyanese)</option>
                            <option value="jam">Creole English (Jamaican)</option>
                            <option value="svc">Creole English (Vincentian)</option>
                            <option value="vic">Creole English (Virgin Islands)</option>
                            <option value="ht">Creole French (Haitian)</option>
                            <option value="acf">Creole French (Saint Lucian)</option>
                            <option value="crs">Creole French (Seselwa)</option>
                            <option value="pov">Creole Portuguese (Upper Guinea)</option>
                            <option value="hr">Croatian</option>
                            <option value="cs">Czech</option>
                            <option value="da">Danish</option>
                            <option value="nl">Dutch</option>
                            <option value="dz">Dzongkha</option>
                            <option value="en">English</option>
                            <option value="eo">Esperanto</option>
                            <option value="et">Estonian</option>
                            <option value="fn">Fanagalo</option>
                            <option value="fo">Faroese</option>
                            <option value="fi">Finnish</option>
                            <option value="fr">French</option>
                            <option value="gl">Galician</option>
                            <option value="ka">Georgian</option>
                            <option value="de">German</option>
                            <option value="el">Greek</option>
                            <option value="grc">Greek (classNameical)</option>
                            <option value="gu">Gujarati</option>
                            <option value="ha">Hausa</option>
                            <option value="haw">Hawaiian</option>
                            <option value="he">Hebrew</option>
                            <option value="hi">Hindi</option>
                            <option value="hu">Hungarian</option>
                            <option value="is">Icelandic</option>
                            <option value="id">Indonesian</option>
                            <option value="kl">Inuktitut (Greenlandic)</option>
                            <option value="ga">Irish Gaelic</option>
                            <option value="it">Italian</option>
                            <option value="ja">Japanese</option>
                            <option value="jv">Javanese</option>
                            <option value="kea">Kabuverdianu</option>
                            <option value="kab">Kabylian</option>
                            <option value="kn">Kannada</option>
                            <option value="kk">Kazakh</option>
                            <option value="km">Khmer</option>
                            <option value="rw">Kinyarwanda</option>
                            <option value="rn">Kirundi</option>
                            <option value="ko">Korean</option>
                            <option value="ku">Kurdish</option>
                            <option value="ckb">Kurdish Sorani</option>
                            <option value="ky">Kyrgyz</option>
                            <option value="lo">Lao</option>
                            <option value="la">Latin</option>
                            <option value="lv">Latvian</option>
                            <option value="lt">Lithuanian</option>
                            <option value="lb">Luxembourgish</option>
                            <option value="mk">Macedonian</option>
                            <option value="mg">Malagasy</option>
                            <option value="ms">Malay</option>
                            <option value="dv">Maldivian</option>
                            <option value="mt">Maltese</option>
                            <option value="gv">Manx Gaelic</option>
                            <option value="mi">Maori</option>
                            <option value="mh">Marshallese</option>
                            <option value="men">Mende</option>
                            <option value="mn">Mongolian</option>
                            <option value="mfe">Morisyen</option>
                            <option value="ne">Nepali</option>
                            <option value="niu">Niuean</option>
                            <option value="no">Norwegian</option>
                            <option value="ny">Nyanja</option>
                            <option value="ur">Pakistani</option>
                            <option value="pau">Palauan</option>
                            <option value="pa">Panjabi</option>
                            <option value="pap">Papiamentu</option>
                            <option value="ps">Pashto</option>
                            <option value="fa">Persian</option>
                            <option value="pis">Pijin</option>
                            <option value="pl">Polish</option>
                            <option value="pt">Portuguese</option>
                            <option value="pot">Potawatomi</option>
                            <option value="qu">Quechua</option>
                            <option value="ro">Romanian</option>
                            <option value="ru">Russian</option>
                            <option value="sm">Samoan</option>
                            <option value="sg">Sango</option>
                            <option value="gd">Scots Gaelic</option>
                            <option value="sr">Serbian</option>
                            <option value="sn">Shona</option>
                            <option value="si">Sinhala</option>
                            <option value="sk">Slovak</option>
                            <option value="sl">Slovenian</option>
                            <option value="so">Somali</option>
                            <option value="st">Sotho, Southern</option>
                            <option value="es">Spanish</option>
                            <option value="srn">Sranan Tongo</option>
                            <option value="sw">Swahili</option>
                            <option value="sv">Swedish</option>
                            <option value="de">Swiss German</option>
                            <option value="syc">Syriac (Aramaic)</option>
                            <option value="tl">Tagalog</option>
                            <option value="tg">Tajik</option>
                            <option value="tmh">Tamashek (Tuareg)</option>
                            <option value="ta">Tamil</option>
                            <option value="te">Telugu</option>
                            <option value="tet">Tetum</option>
                            <option value="th">Thai</option>
                            <option value="bo">Tibetan</option>
                            <option value="ti">Tigrinya</option>
                            <option value="tpi">Tok Pisin</option>
                            <option value="tkl">Tokelauan</option>
                            <option value="to">Tongan</option>
                            <option value="tn">Tswana</option>
                            <option value="tr">Turkish</option>
                            <option value="tk">Turkmen</option>
                            <option value="tvl">Tuvaluan</option>
                            <option value="uk">Ukrainian</option>
                            <option value="ppk">Uma</option>
                            <option value="uz">Uzbek</option>
                            <option value="vi">Vietnamese</option>
                            <option value="wls">Wallisian</option>
                            <option value="cy">Welsh</option>
                            <option value="wo">Wolof</option>
                            <option value="xh">Xhosa</option>
                            <option value="yi">Yiddish</option>
                            <option value="zu-ZA">Zulu</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="row" style={{ padding: '10px', marginTop: '3px' }}>
                      <div className="chatwindow" style={{ display: 'none' }}>
                        <div className="col-md-12">
                          <div className=" form-group custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="live_chat_enable"
                              name="live_chat_enable"
                              value={'yes'}
                            />
                            <label className="custom-control-label" htmlFor="live_chat_enable">
                              Live Chat
                            </label>
                          </div>
                        </div>

                        <div className="col-md-12 hide-chat">
                          <div className="form-group custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="open_chat_new_tab"
                              name="open_chat_new_tab"
                              value="yes"
                            // defaultChecked={aiFormData.open_chat_new_tab === 'yes' ? true : false}
                            // onChange={(e) => setAiFormData({ ...aiFormData, open_chat_new_tab: e.target.value })}
                            />
                            <label className="custom-control-label" htmlFor="open_chat_new_tab">
                              Open chat window in tab?:
                            </label>
                          </div>
                        </div>

                        <div className="col-md-6 hide-chat">
                          <div className="form-group ">
                            <label>Live chat button text</label>
                            <input
                              type="text"
                              className="form-control"
                              name="live_chat_button_text"
                              id="live_chat_button_text"
                            // value={translationData.live_chat_button_text || ''}
                            // onChange={(e) => setTranslationData({ ...translationData, live_chat_button_text: e.target.value })}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 hide-chat">
                          <div className="form-group">
                            <label>Live Chat Url</label>
                            <input
                              type="text"
                              className="form-control"
                              id="live_chat_url"
                              name="live_chat_url"
                            // value={translationData.live_chat_url || ''}
                            // onChange={(e) => setTranslationData({ ...translationData, live_chat_url: e.target.value })}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="speech_text_response"
                            name="speech_text_response"
                            value="yes"
                          // checked={aiFormData.speech_text_response === 'yes'}
                          // onChange={(e) => setAiFormData({ ...aiFormData, speech_text_response: e.target.value })}
                          />
                          <label className="custom-control-label" htmlFor="speech_text_response">
                            Enable Speech Text Response? (Desktop):
                          </label>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="enable_speech_btn"
                            name="enable_speech_btn"
                            value="yes"
                          // checked={aiFormData.speech_text_response === 'yes'}
                          // onChange={(e) => setAiFormData({ ...aiFormData, speech_text_response: e.target.value })}
                          />
                          <label className="custom-control-label" htmlFor="enable_speech_btn">
                            Enable Speech Button?
                          </label>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="enable_auto_speech_response"
                            name="enable_auto_speech_response"
                            value="yes"
                          // checked={aiFormData.speech_text_response === 'yes'}
                          // onChange={(e) => setAiFormData({ ...aiFormData, speech_text_response: e.target.value })}
                          />
                          <label className="custom-control-label" htmlFor="enable_auto_speech_response">
                            Enable Auto Speech Button Response
                          </label>
                        </div>
                      </div>
                      <div className="col-md-12 ">
                        <div className="form-group custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="enable_voice_detection"
                            name="enable_voice_detection"
                            value="yes"
                          />
                          <label className="custom-control-label" htmlFor="enable_voice_detection">
                            Enable Voice Detection (instead of camera)?{' '}
                          </label>
                        </div>
                      </div>
                      <div className="col-md-12  hide_voicedetection">
                        <div className="form-group">
                          <label>Voice Detection Threshold (0.1 - 100):</label>
                          <input
                            type="number"
                            id="voice_detection_threshold"
                            className="form-control"
                            min="0.1"
                            max="100"
                            step="0.1"
                            placeholder="Enter threshold (0.1 - 100)"
                          />

                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="enable_face_detection"
                            name="enable_face_detection"
                            value="yes"
                          // checked={aiFormData.speech_text_response === 'yes'}
                          // onChange={(e) => setAiFormData({ ...aiFormData, speech_text_response: e.target.value })}
                          />
                          <label className="custom-control-label" htmlFor="enable_face_detection">
                            Enable FaceDetection?{' '}
                          </label>
                        </div>
                      </div>



                      <div className="col-md-12 hide_facedetection">
                        <div className="form-group custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="disable_camera_front"
                            name="disable_camera_front"
                            value="yes"
                          // checked={aiFormData.speech_text_response === 'yes'}
                          // onChange={(e) => setAiFormData({ ...aiFormData, speech_text_response: e.target.value })}
                          />
                          <label className="custom-control-label" htmlFor="disable_camera_front">
                            Hide Camera From Front?
                          </label>
                        </div>
                      </div>

                      <div className="col-md-4 hide_facedetection">
                        <div className="form-group">
                          <label>Face Detection Time Range (seconds):</label>
                          <input id="fecedetection_time_range" />
                        </div>
                      </div>



                      <div className="col-md-4 hide_facedetection">
                        <span>
                          <strong>Face Detection Camera Position</strong>
                        </span>
                        <div className="face_detection_section">
                          <div className="form-group custom-control custom-radio">
                            <input
                              type="radio"
                              name="face_detection_location"
                              className="custom-control-input"
                              id="top-right"
                              value="top-right"
                            />
                            <label className="custom-control-label" htmlFor="top-right">
                              Top Right
                            </label>
                          </div>
                          <div className="form-group custom-control custom-radio">
                            <input
                              type="radio"
                              name="face_detection_location"
                              className="custom-control-input"
                              id="top-left"
                              value="top-left"
                            />
                            <label className="custom-control-label" htmlFor="top-left">
                              Top Left
                            </label>
                          </div>
                          <div className="form-group custom-control custom-radio">
                            <input
                              type="radio"
                              name="face_detection_location"
                              className="custom-control-input"
                              id="bottom-left"
                              value="bottom-left"
                            />
                            <label className="custom-control-label" htmlFor="bottom-left">
                              Bottom Left
                            </label>
                          </div>

                          <div className="form-group custom-control custom-radio">
                            <input
                              type="radio"
                              name="face_detection_location"
                              className="custom-control-input"
                              id="bottom-right"
                              value="bottom-right"
                            />
                            <label className="custom-control-label" htmlFor="bottom-right">
                              Bottom Right
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4 hide_facedetection">
                        <div className="form-group">
                          <label htmlFor="time_rane">
                            Enter Time Range in Second:
                            <input
                              type="number"
                              className="form-control"
                              id="time_rane"
                              name="time_rane"

                            // checked={aiFormData.speech_text_response === 'yes'}
                            // onChange={(e) => setAiFormData({ ...aiFormData, speech_text_response: e.target.value })}
                            />
                          </label>
                        </div>
                      </div>

                      <div className="col-md-12" style={{ display: 'none' }}>
                        <div className="form-group custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="enable_rizwan_event"
                            name="enable_rizwan_event"
                            value="yes"
                          // checked={aiFormData.speech_text_response === 'yes'}
                          // onChange={(e) => setAiFormData({ ...aiFormData, speech_text_response: e.target.value })}
                          />
                          <label className="custom-control-label" htmlFor="enable_rizwan_event">
                            Enable Rizwan Event?
                          </label>
                        </div>
                      </div>

                      <div className="col-md-12 hide_rizwan_btn">
                        <div className="form-group custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="enable_rizwan_btn"
                            name="enable_rizwan_btn"
                            value="yes"
                          // checked={aiFormData.speech_text_response === 'yes'}
                          // onChange={(e) => setAiFormData({ ...aiFormData, speech_text_response: e.target.value })}
                          />
                          <label className="custom-control-label" htmlFor="enable_rizwan_btn">
                            Enable Rizwan Event Button?
                          </label>
                        </div>
                      </div>

                      <div className="col-md-12 enable_rizwan_btn_child">
                        <div className="form-group">
                          <label htmlFor="enable_rizwan_btn_text_1">
                            Enter Rizwan Event Step 1 Button Text
                            <input
                              type="text"
                              className="form-control"
                              id="enable_rizwan_btn_text_1"
                              name="enable_rizwan_btn_text_1"
                            />
                          </label>
                        </div>
                      </div>

                      <div className="col-md-12 enable_rizwan_btn_child">
                        <div className="form-group">
                          <label htmlFor="enable_rizwan_btn_text">
                            Enter Rizwan Event Step 2 Button Text
                            <input
                              type="text"
                              className="form-control"
                              id="enable_rizwan_btn_text"
                              name="enable_rizwan_btn_text"
                            />
                          </label>
                        </div>
                      </div>

                      <div className="col-md-12 hide_rizwan_btn">
                        <div className="form-group custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="enable_rizwan_manual_script"
                            name="enable_rizwan_manual_script"
                            value="yes"
                          // checked={aiFormData.speech_text_response === 'yes'}
                          // onChange={(e) => setAiFormData({ ...aiFormData, speech_text_response: e.target.value })}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="enable_rizwan_manual_script"
                          >
                            Enable Rizwan Event Manual Script?{' '}
                          </label>
                        </div>
                      </div>

                      <div className="col-md-4 hide_rizwan_btn">
                        <div className="form-group">
                          <label htmlFor="time_rane_splash">
                            Enter Time Range in Second for Splash Screen Reload Button:
                            <input
                              type="number"
                              className=""
                              id="time_rane_splash"
                              name="time_rane_splash"
                            />
                          </label>
                        </div>
                      </div>

                      <div className="col-md-12" style={{ display: 'none' }}>
                        <div className="form-group custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="enable_python_script"
                            name="enable_python_script"
                            value="yes"
                          />
                          <label className="custom-control-label" htmlFor="enable_python_script">
                            Enable Python Script?
                          </label>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div
                          className="form-group custom-control custom-checkbox"
                          style={{ display: 'none' }}
                        >
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="bypass_login"
                            name="bypass_login"
                            value="yes"
                          />
                          <label className="custom-control-label" htmlFor="bypass_login">
                            Bypass the login?
                          </label>
                        </div>
                      </div>

                      {/* <div className="col-md-12">
                        <span>
                          <strong>
                            Which tool you want to enable for Speech to Text?
                          </strong>
                        </span>
                        <div className="form-group custom-control custom-radio">
                          <input
                            type="radio"
                            className="custom-control-input"
                            name="speech_tool"
                            id="javascript"
                            value="javascript"
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="javascript"
                          >
                            Javascript
                          </label>
                        </div>
                        <div className="form-group custom-control custom-radio">
                          <input
                            type="radio"
                            className="custom-control-input"
                            id="google"
                            name="speech_tool"
                            value="google"
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="google"
                          >
                            Google Speech API
                          </label>
                        </div>
                      </div> */}

                      <div className="col-md-6" id="speech_container">
                        <div className="form-group">
                          <label htmlFor="speech_tool">
                            Which tool you want to enable for Speech to Text?
                          </label>
                          <select
                            id="speech_tool"
                            name="speech_tool"
                            className="form-control"
                          ></select>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="stream_timeout_seconds">
                            Time to Disconnect from Live Avatar (Seconds):
                          </label>
                          <input
                            style={{ height: '44px' }}
                            type="number"
                            className="form-control"
                            id="stream_timeout_seconds"
                            name="stream_timeout_seconds"
                            min="30"
                            max="1200"
                            placeholder="Enter time (30-1200 seconds)"
                          />
                          <small className="form-text text-muted">
                            Maximum streaming time before switching to looped video (30-1200 seconds, default: 45)
                          </small>
                        </div>
                      </div>
                    </div>

                    {/* WebSocket Configuration Section */}
                    <div className="row" id="websocketConfigSection" style={{ marginTop: '30px' }}>
                      <div className="col-md-12">
                        <div style={{ 
                          padding: '20px', 
                          border: '2px solid #e3e6f0', 
                          borderRadius: '12px',
                          backgroundColor: '#f8f9fa',
                          marginBottom: '20px'
                        }}>
                          <h3 style={{ marginBottom: '15px', color: '#2d3748', display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <span style={{ fontSize: '24px' }}>🔌</span>
                            AI Human WebSocket API Configuration
                          </h3>
                          <p style={{ color: '#6c757d', marginBottom: '20px' }}>
                            Configure WebSocket server settings for third-party integrations. Manage API keys, rate limits, and security settings.
                          </p>

                          {/* Enable/Disable WebSocket */}
                          <div className="form-group custom-control custom-checkbox" style={{ marginBottom: '20px' }}>
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="websocket_enabled"
                              name="websocket_enabled"
                            />
                            <label className="custom-control-label" htmlFor="websocket_enabled">
                              <strong>Enable WebSocket Server</strong>
                              <small className="d-block text-muted">Allow third-party applications to control the avatar via WebSocket API</small>
                            </label>
                          </div>

                          {/* WebSocket Settings Container (shown when enabled) */}
                          <div id="websocketSettingsContainer" style={{ display: 'none' }}>
                            
                            {/* AI Human WebSocket URL */}
                            <div className="row" style={{ marginBottom: '20px' }}>
                              <div className="col-md-12">
                                <div className="form-group">
                                  <label><strong>AI Human WebSocket URL</strong></label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="aiHumanWebsocketUrl"
                                    name="aiHumanWebsocketUrl"
                                    placeholder="https://example.com/websocket-interface"
                                  />
                                  <small className="form-text text-muted">
                                    Enter the URL for the AI Human WebSocket interface. This will be displayed in an iframe when WebSocket is enabled.
                                  </small>
                                </div>
                              </div>
                            </div>

                            {/* API Keys Management */}
                            <div style={{ 
                              padding: '15px', 
                              backgroundColor: '#fff', 
                              borderRadius: '8px',
                              marginBottom: '20px',
                              border: '1px solid #dee2e6'
                            }}>
                              <h5 style={{ marginBottom: '15px' }}>API Keys</h5>
                              <p style={{ fontSize: '13px', color: '#6c757d', marginBottom: '15px' }}>
                                Generate API keys for third-party applications to authenticate with your WebSocket server.
                              </p>

                              {/* Generate New API Key */}
                              <div className="row" style={{ marginBottom: '15px' }}>
                                <div className="col-md-8">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="newApiKeyName"
                                    placeholder="e.g., Production Server, Test Client"
                                  />
                                </div>
                                <div className="col-md-4">
                                  <button
                                    type="button"
                                    className="btn btn-primary w-100"
                                    id="generateApiKeyBtn"
                                  >
                                    Generate Key
                                  </button>
                                </div>
                              </div>

                              {/* Generated Key Display */}
                              <div id="generatedKeyDisplay" style={{ display: 'none', marginBottom: '15px' }}>
                                <div style={{ 
                                  padding: '15px', 
                                  backgroundColor: '#d4edda', 
                                  borderRadius: '8px',
                                  border: '1px solid #c3e6cb'
                                }}>
                                  <strong style={{ color: '#155724' }}>✅ New API Key Generated!</strong>
                                  <p style={{ fontSize: '12px', color: '#155724', marginTop: '5px', marginBottom: '10px' }}>
                                    Copy this key now - it won't be shown again!
                                  </p>
                                  <div style={{ display: 'flex', gap: '10px' }}>
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="generatedKeyValue"
                                      readOnly
                                      style={{ fontFamily: 'monospace', fontSize: '12px' }}
                                    />
                                    <button
                                      type="button"
                                      className="btn btn-outline-secondary"
                                      id="copyGeneratedKeyBtn"
                                    >
                                      Copy
                                    </button>
                                  </div>
                                </div>
                              </div>

                              {/* Existing API Keys List */}
                              <div id="apiKeysList">
                                <p style={{ fontSize: '13px', fontWeight: '600', marginBottom: '10px' }}>
                                  Active API Keys (<span id="apiKeysCount">0</span>)
                                </p>
                                <div id="apiKeysContainer"></div>
                              </div>
                            </div>

                            {/* Security Settings */}
                            <div style={{ 
                              padding: '15px', 
                              backgroundColor: '#fff', 
                              borderRadius: '8px',
                              marginBottom: '20px',
                              border: '1px solid #dee2e6'
                            }}>
                              <h5 style={{ marginBottom: '15px' }}>Security Settings</h5>
                              
                              {/* CORS Origins */}
                              <div style={{ marginBottom: '15px' }}>
                                <label><strong>Allowed Origins (CORS)</strong></label>
                                <p style={{ fontSize: '12px', color: '#6c757d', marginBottom: '10px' }}>
                                  Restrict WebSocket connections to specific domains. Leave empty to allow all origins.
                                </p>
                                <div className="row" style={{ marginBottom: '10px' }}>
                                  <div className="col-md-8">
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="newOrigin"
                                      placeholder="https://example.com"
                                    />
                                  </div>
                                  <div className="col-md-4">
                                    <button
                                      type="button"
                                      className="btn btn-outline-primary w-100"
                                      id="addOriginBtn"
                                    >
                                      Add Origin
                                    </button>
                                  </div>
                                </div>
                                <div id="originsContainer"></div>
                              </div>
                            </div>

                            {/* Performance Settings */}
                            <div style={{ 
                              padding: '15px', 
                              backgroundColor: '#fff', 
                              borderRadius: '8px',
                              marginBottom: '20px',
                              border: '1px solid #dee2e6'
                            }}>
                              <h5 style={{ marginBottom: '15px' }}>Performance & Limits</h5>
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label>Rate Limit (commands/minute)</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="rateLimitPerMinute"
                                      min="1"
                                      max="1000"
                                      defaultValue="60"
                                    />
                                    <small className="form-text text-muted">Maximum commands per minute per client</small>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label>Queue Max Size</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="queueMaxSize"
                                      min="1"
                                      max="500"
                                      defaultValue="50"
                                    />
                                    <small className="form-text text-muted">Maximum queued speech commands</small>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label>Command Timeout (ms)</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="commandTimeout"
                                      min="1000"
                                      max="300000"
                                      defaultValue="30000"
                                    />
                                    <small className="form-text text-muted">Timeout for command execution</small>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label>Session Timeout (ms)</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="sessionTimeout"
                                      min="60000"
                                      max="3600000"
                                      defaultValue="300000"
                                    />
                                    <small className="form-text text-muted">Idle session timeout</small>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label>Max Connections</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="maxConnections"
                                      min="1"
                                      max="100"
                                      defaultValue="10"
                                    />
                                    <small className="form-text text-muted">Maximum concurrent connections</small>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label>Port</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="websocketPort"
                                      min="1024"
                                      max="65535"
                                      defaultValue="8080"
                                      disabled
                                    />
                                    <small className="form-text text-muted">WebSocket server port</small>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Iframe Styling Configuration */}
                            <div style={{ 
                              padding: '15px', 
                              backgroundColor: '#fff', 
                              borderRadius: '8px',
                              marginBottom: '20px',
                              border: '1px solid #dee2e6'
                            }}>
                              <h5 style={{ marginBottom: '15px' }}>Iframe Display Settings</h5>
                              <p style={{ fontSize: '12px', color: '#6c757d', marginBottom: '15px' }}>
                                Customize the position and appearance of the WebSocket iframe interface.
                              </p>
                              
                              <div className="row">
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label>Bottom Offset (px)</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="iframeBottom"
                                      min="0"
                                      max="500"
                                      defaultValue="20"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label>Left Position (%)</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="iframeLeft"
                                      min="0"
                                      max="100"
                                      defaultValue="50"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label>Width (px)</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="iframeWidth"
                                      min="300"
                                      max="2000"
                                      defaultValue="800"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label>Height (px)</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="iframeHeight"
                                      min="200"
                                      max="1200"
                                      defaultValue="500"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label>Padding (px)</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="iframePadding"
                                      min="0"
                                      max="100"
                                      
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label>Border Radius (px)</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="iframeBorderRadius"
                                      min="0"
                                      max="50"
                                      defaultValue="16"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label>Z-Index</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="iframeZIndex"
                                      min="1"
                                      max="9999"
                                      defaultValue="1000"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Connection Info */}
                            <div style={{ 
                              padding: '15px', 
                              backgroundColor: '#e3f2fd', 
                              borderRadius: '8px',
                              border: '1px solid #2196f3'
                            }}>
                              <p style={{ fontSize: '13px', fontWeight: '600', marginBottom: '10px' }}>
                                📡 Connection Information
                              </p>
                              <p style={{ fontSize: '12px', marginBottom: '5px' }}>
                                WebSocket URL: <code style={{ backgroundColor: '#fff', padding: '2px 6px', borderRadius: '4px' }}>
                                  ws://localhost:<span id="displayPort">8080</span>
                                </code>
                              </p>
                              <p style={{ fontSize: '11px', color: '#666', marginBottom: '10px' }}>
                                Third-party applications should connect to this URL and authenticate with an API key.
                              </p>
                              <p style={{ fontSize: '11px', padding: '10px', backgroundColor: '#fff3cd', borderRadius: '4px', border: '1px solid #ffc107', marginBottom: '0' }}>
                                ℹ️ <strong>Multi-User Support:</strong> All users share the same port. 
                                User isolation is achieved through API key authentication.
                              </p>
                            </div>

                          </div>
                        </div>
                      </div>

                      {/* <div className="col-md-12">
                        <div className="form-group">
                          <span>
                            <strong>Select LLM Option:</strong>
                          </span>
                          <div className="form-group custom-control custom-radio">
                            <input
                              type="radio"
                              className="custom-control-input"
                              id="llm_openai"
                              name="llm_option"
                              value="openai"
                              checked
                            />
                            <label
                              className="custom-control-label"
                              for="llm_openai"
                            >
                              Openai
                            </label>
                          </div>
                          <div className="form-group custom-control custom-radio">
                            <input
                              type="radio"
                              className="custom-control-input"
                              id="llm_python"
                              name="llm_option"
                              value="python"
                              checked
                            />
                            <label
                              className="custom-control-label"
                              for="llm_python"
                            >
                              Python
                            </label>
                          </div>
                          <div className="form-group custom-control custom-radio">
                            <input
                              type="radio"
                              className="custom-control-input"
                              id="llm_motive"
                              name="llm_option"
                              value="motive"
                            />
                            <label
                              className="custom-control-label"
                              for="llm_motive"
                            >
                              Motive Intelligence
                            </label>
                          </div>
                        </div>
                      </div> */}

                      <div className="col-md-12" id="motiveFields" style={{ display: 'none' }}>
                        {/* <div>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Organization:</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="motive_organization"
                                  name="motive_organization"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Space:</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="motive_space"
                                  name="motive_space"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Agent:</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="motive_agent"
                                  name="motive_agent"
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Deployment:</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="motive_deployment"
                                  name="motive_deployment"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Breaer Token:</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="motivetoken"
                                  name="motivetoken"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Function:</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="motive_function"
                                  name="motive_function"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Knowledge:</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="motive_knowledge"
                                  name="motive_knowledge"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Temprature:</label>
                                <input
                                  type="number"
                                  className="form-control"
                                  id="motive_temprature"
                                  name="motive_temprature"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Motive API Base Url:</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="motive_baseurl"
                                  name="motive_baseurl"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Customize no found text:</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="motive_outputtext"
                                  name="motive_outputtext"
                                />
                              </div>
                            </div>

                            <div className="text-center mt-4">
                              <button
                                type="button"
                                className="btn btn-primary btn-lg"
                                id="submitBtnmotive"
                              >
                                Run Motive Output Text Customization API
                              </button>
                            </div>
                            <div
                              id="resultContainer"
                              className="result-container"
                            ></div>
                          </div>
                        </div> */}

                        <div
                          id="trainingSection"
                          className="training-status"
                          style={{ display: 'none' }}
                        >
                          <div className="alert alert-info">
                            <h6>
                              <i className="bi bi-play-circle"></i> Training Available
                            </h6>
                            <p>
                              Configuration updated successfully. Click below to start training.
                            </p>
                            <button
                              type="button"
                              className="btn btn-success btn-sm"
                              id="startTrainingBtn"
                            >
                              <span
                                className="training-spinner spinner-border spinner-border-sm me-2"
                                role="status"
                                style={{ display: 'none' }}
                              ></span>
                              Start Training
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row" style={{ display: 'none' }}>
                      <div className="col-md-12">
                        <h4>
                          <strong>Experience Schedule:</strong>
                        </h4>
                        <div
                          className="form-group"
                          style={{ marginTop: '5px', marginBottom: '5px' }}
                        >
                          <div className="day-slot custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="monday-open"
                              name="monday-open"
                              checked
                            />
                            <label className="custom-control-label" htmlFor="monday-open">
                              Monday:
                            </label>
                            <div className="timesection">
                              <input type="time" id="monday-start" name="monday-start" /> to
                              <input type="time" id="monday-end" name="monday-end" />
                            </div>
                          </div>
                          <div className="day-slot custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="tuesday-open"
                              name="tuesday-open"
                              checked
                            />
                            <label className="custom-control-label" htmlFor="tuesday-open">
                              Tuesday:
                            </label>
                            <div className="timesection">
                              <input type="time" id="tuesday-start" name="tuesday-start" /> to
                              <input type="time" id="tuesday-end" name="tuesday-end" />
                            </div>
                          </div>
                          <div className="day-slot custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="wednesday-open"
                              name="wednesday-open"
                              checked
                            />
                            <label className="custom-control-label" htmlFor="wednesday-open">
                              Wednesday:
                            </label>
                            <div className="timesection">
                              <input type="time" id="wednesday-start" name="wednesday-start" /> to
                              <input type="time" id="wednesday-end" name="wednesday-end" />
                            </div>
                          </div>
                          <div className="day-slot custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="thursday-open"
                              name="thursday-open"
                              checked
                            />
                            <label className="custom-control-label" htmlFor="thursday-open">
                              Thursday:
                            </label>
                            <div className="timesection">
                              <input type="time" id="thursday-start" name="thursday-start" /> to
                              <input type="time" id="thursday-end" name="thursday-end" />
                            </div>
                          </div>
                          <div className="day-slot custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="friday-open"
                              name="friday-open"
                              checked
                            />
                            <label className="custom-control-label" htmlFor="friday-open">
                              Friday:
                            </label>
                            <div className="timesection">
                              <input type="time" id="friday-start" name="friday-start" /> to
                              <input type="time" id="friday-end" name="friday-end" />
                            </div>
                          </div>
                          <div className="day-slot custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="saturday-open"
                              name="saturday-open"
                              checked
                            />
                            <label className="custom-control-label" htmlFor="saturday-open">
                              Saturday:
                            </label>
                            <div className="timesection">
                              <input type="time" id="saturday-start" name="saturday-start" /> to
                              <input type="time" id="saturday-end" name="saturday-end" />
                            </div>
                          </div>
                          <div className="day-slot custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="sunday-open"
                              name="sunday-open"
                              checked
                            />
                            <label className="custom-control-label" htmlFor="sunday-open">
                              Sunday:
                            </label>
                            <div className="timesection">
                              <input type="time" id="sunday-start" name="sunday-start" /> to
                              <input type="time" id="sunday-end" name="sunday-end" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                {/* <!-- Step 2 --> */}
                <h5>Interface</h5>
                <section>
                  {/* Sub section */}
                  <div className="menu-card-ai">
                    <div className="row">
                      <div style={{ display: 'none' }}>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>AWS Access Key :</label>
                            <input
                              type="text"
                              className="form-control"
                              name="aws_access_key"
                              id="aws_access_key"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>AWS Secret Key :</label>
                            <input
                              type="text"
                              className="form-control"
                              name="aws_secret_key"
                              id="aws_secret_key"
                            />
                          </div>
                        </div>
                      </div>

                      <h2 style={{ marginBottom: '10px' }}>On Screen Graphics</h2>


                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="ask_your_question">Ask Your Question text:</label>
                          <input
                            type="text"
                            className="form-control"
                            name="ask_your_question"
                            id="ask_your_question"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="listening_text">Listening Text:</label>
                          <input
                            type="text"
                            className="form-control"
                            id="listening_text"
                            name="listening_text"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row" style={{ display: 'none' }}>
                      <div className="col-md-6" >
                        <div className="form-group">
                          <label>
                            Buttons color
                            <div className="font-14">
                              use <code>.gradient-colorpicker</code> in your input element.
                            </div>
                          </label>
                          <input
                            type="text"
                            className="complex-colorpicker form-control asColorPicker-input site_brand_color"
                            id="site_brand_color"
                            name="site_brand_color"
                          // value={translationData.site_brand_color || ''}
                          // onChange={(e) => setTranslationData({ ...translationData, site_brand_color: e.target.value })}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="footer_text">Avatar Footer Text:</label>
                          <input
                            type="text"
                            className="form-control"
                            id="footer_text"
                            name="footer_text"
                          // value={translationData.footer_text || ''}
                          // onChange={(e) => setTranslationData({ ...translationData, footer_text: e.target.value })}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="footer_text">Avatar Before Loading Text:</label>
                          <input
                            type="text"
                            className="form-control"
                            id="avatar_before_loading_text"
                            name="avatar_before_loading_text"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Avatar Footer Text Background Color:</label>
                          <input
                            type="text"
                            className="complex-colorpicker form-control asColorPicker-input welcom_text_back_color"
                            id="welcom_text_back_color"
                            name="welcom_text_back_color"
                          // value={translationData.welcom_text_back_color || ''}
                          // onChange={(e) => setTranslationData({ ...translationData, welcom_text_back_color: e.target.value })}
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Avatar Footer Text Color:</label>
                          <input
                            type="text"
                            className="complex-colorpicker form-control welcom_text_color asColorPicker-input"
                            id="welcom_text_color"
                            name="welcom_text_color"
                          // value={translationData.welcom_text_color || ''}
                          // onChange={(e) => setTranslationData({ ...translationData, welcom_text_color: e.target.value })}
                          />
                        </div>
                      </div>
                    </div>

                    {/* <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <p>Splash Page Logo</p>
                          <input
                            type="file"
                            id="image"
                            name="image"
                            accept="image/*"
                            style={{ display: 'none' }}
                            required
                          />

                          <div id="response"></div>
                          <img id="imagee" src="" alt="Uploaded Image" />
                          <div>
                            <label htmlFor="image" className="btn btn-primary">
                              Choose logo
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <p>Avatar Page Corner Logo</p>

                          <input
                            type="file"
                            id="avtar_page_image"
                            name="avtar_page_image"
                            accept="image/*"
                            style={{ display: 'none' }}
                            required
                          />

                          <div id="response"></div>
                          <img id="avtar_page_image_src" src="" alt="Uploaded Image" />
                          <div>
                            <label htmlFor="avtar_page_image" className="btn btn-primary">
                              Choose Avatar Page logo
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <span>
                          <strong>Avatar Page Corner Logo Location</strong>
                        </span>
                        <div className="form-group custom-control custom-radio">
                          <input
                            type="radio"
                            className="custom-control-input"
                            name="avtar_page_image_location"
                            id="top-right2"
                            value="top-right"
                          />
                          <label className="custom-control-label" htmlFor="top-right2">
                            Top Right
                          </label>
                        </div>

                        <div className="form-group custom-control custom-radio">
                          <input
                            type="radio"
                            className="custom-control-input"
                            name="avtar_page_image_location"
                            id="top-left2"
                            value="top-left"
                          />
                          <label className="custom-control-label" htmlFor="top-left2">
                            Top Left
                          </label>
                        </div>

                        <div className="form-group custom-control custom-radio">
                          <input
                            type="radio"
                            className="custom-control-input"
                            name="avtar_page_image_location"
                            value="bottom-left"
                            id="bottom-left2"
                          />
                          <label className="custom-control-label" htmlFor="bottom-left2">
                            Bottom Left
                          </label>
                        </div>

                        <div className="form-group custom-control custom-radio">
                          <input
                            type="radio"
                            className="custom-control-input"
                            id="bottom-right2"
                            name="avtar_page_image_location"
                            value="bottom-right"
                          />
                          <label className="custom-control-label" htmlFor="bottom-right2">
                            Bottom Right
                          </label>
                        </div>
                      </div>
                    </div> */}

                    {/* Enhanced Splash Page Logo Section */}
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Splash Page Logo:</label>
                          <div className="image-upload-container">
                            <input
                              type="file"
                              id="image"
                              name="image"
                              accept="image/*"
                              className="image-upload-input"
                              required
                            />

                            <div className="image-preview-container">
                              {/* <div className="image-placeholder" id="splash-logo-placeholder">
                                <div className="placeholder-icon">
                                  <i className="fas fa-cloud-upload-alt"></i>
                                </div>
                                <p className="placeholder-text">No logo uploaded</p>
                                <p className="placeholder-subtext">
                                  Click to upload splash page logo
                                </p>
                              </div> */}
                              <img
                                id="imagee"
                                className="uploaded-image"
                                src=""
                                alt="Uploaded Splash Logo"
                              />
                            </div>

                            <div className="upload-actions">
                              <label
                                htmlFor="image"
                                className="btn btn-primary upload-btn"
                                id="upload-btn"
                              >
                                <i className="fas fa-upload"></i> Choose Logo
                              </label>
                              {/* <button
                                type="button"
                                className="btn btn-primary remove-btn"
                                id="remove-splash-logo"
                              >
                                Remove
                              </button> */}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Splash page Text:</label>
                          <input
                            type="text"
                            className="form-control"
                            name="home_screen_btn_text1"
                            id="home_screen_btn_text1"
                          />
                        </div>
                      </div>


                    </div>

                    {/* Enhanced Avatar Page Logo Section */}
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Avatar Page Corner Logo:</label>
                          <div className="image-upload-container">
                            <input
                              type="file"
                              id="avtar_page_image"
                              name="avtar_page_image"
                              accept="image/*"
                              className="image-upload-input"
                              required
                            />

                            <div className="image-preview-container">
                              {/* <div className="image-placeholder" id="avatar-logo-placeholder">
                                <div className="placeholder-icon">
                                  <i className="fas fa-image"></i>
                                </div>
                                <p className="placeholder-text">No avatar logo uploaded</p>
                                <p className="placeholder-subtext">
                                  Click to upload avatar page logo
                                </p>
                              </div> */}
                              <img
                                id="avtar_page_image_src"
                                className="uploaded-image"
                                src=""
                                alt="Uploaded Avatar Logo"
                              />
                            </div>

                            <div className="upload-actions">
                              <label
                                htmlFor="avtar_page_image"
                                className="btn btn-primary upload-btn"
                              >
                                <i className="fas fa-upload"></i> Choose Logo
                              </label>
                              {/* <button
                                type="button"
                                className="btn btn-primary remove-btn"
                                id="remove-avatar-logo"
                              >
                                Remove
                              </button> */}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6 form-group">
                        {/* <div className="logo-position-section">
                          <h5 className="position-title">Avatar Page Corner Logo Location</h5>
                          <div className="position-grid">
                            <div className="position-option">
                              <input
                                type="radio"
                                className="position-radio"
                                name="avtar_page_image_location"
                                id="top-right2"
                                value="top-right"
                              />
                              <label className="position-label" htmlFor="top-right2">
                                <div className="position-icon top-right-icon">
                                  <i className="fas fa-arrow-up-right"></i>
                                </div>
                                <span>Top Right</span>
                              </label>
                            </div>

                            <div className="position-option">
                              <input
                                type="radio"
                                className="position-radio"
                                name="avtar_page_image_location"
                                id="top-left2"
                                value="top-left"
                              />
                              <label className="position-label" htmlFor="top-left2">
                                <div className="position-icon top-left-icon">
                                  <i className="fas fa-arrow-up-left"></i>
                                </div>
                                <span>Top Left</span>
                              </label>
                            </div>

                            <div className="position-option">
                              <input
                                type="radio"
                                className="position-radio"
                                name="avtar_page_image_location"
                                value="bottom-left"
                                id="bottom-left2"
                              />
                              <label className="position-label" htmlFor="bottom-left2">
                                <div className="position-icon bottom-left-icon">
                                  <i className="fas fa-arrow-down-left"></i>
                                </div>
                                <span>Bottom Left</span>
                              </label>
                            </div>

                            <div className="position-option">
                              <input
                                type="radio"
                                className="position-radio"
                                id="bottom-right2"
                                name="avtar_page_image_location"
                                value="bottom-right"
                              />
                              <label className="position-label" htmlFor="bottom-right2">
                                <div className="position-icon bottom-right-icon">
                                  <i className="fas fa-arrow-down-right"></i>
                                </div>
                                <span>Bottom Right</span>
                              </label>
                            </div>
                          </div>
                        </div> */}
                        <label className="position-title">Avatar Page Corner Logo Location:</label>
                        <div className="logo-position-section">
                          <div className="position-grid">
                            <label className="position-card" htmlFor="top-left2">
                              <input
                                type="radio"
                                className="position-radio"
                                name="avtar_page_image_location"
                                id="top-left2"
                                value="top-left"
                              />
                              <div className="position-content">
                                <i className="fas fa-arrow-up-left"></i>
                                <span className="postion-text">Top Left</span>
                              </div>
                            </label>

                            <label className="position-card" htmlFor="top-right2">
                              <input
                                type="radio"
                                className="position-radio"
                                name="avtar_page_image_location"
                                id="top-right2"
                                value="top-right"
                              />
                              <div className="position-content">
                                <i className="fas fa-arrow-up-right"></i>
                                <span className="postion-text">Top Right</span>
                              </div>
                            </label>



                            <label className="position-card" htmlFor="bottom-left2">
                              <input
                                type="radio"
                                className="position-radio"
                                name="avtar_page_image_location"
                                id="bottom-left2"
                                value="bottom-left"
                              />
                              <div className="position-content">
                                <i className="fas fa-arrow-down-left"></i>
                                <span className="postion-text">Bottom Left</span>
                              </div>
                            </label>

                            <label className="position-card" htmlFor="bottom-right2">
                              <input
                                type="radio"
                                className="position-radio"
                                name="avtar_page_image_location"
                                id="bottom-right2"
                                value="bottom-right"
                              />
                              <div className="position-content">
                                <i className="fas fa-arrow-down-right"></i>
                                <span className="postion-text">Bottom Right</span>
                              </div>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Upload video to show before streaming of Avatar</label>

                          {/* Upload Section */}
                          <div className="video-upload-container">
                            <div className="upload-area" id="beforeAvatarUploadArea">
                              <input
                                type="file"
                                id="beforeAvatarFileInput"
                                accept="video/*"
                                className="file-input"
                                style={{ height: '100%' }}
                              />
                              <div className="upload-placeholder">
                                <i className="bi bi-cloud-upload"></i>
                                <h5>Drop your video here or click to browse</h5>
                              </div>
                              <div
                                className="upload-preview"
                                id="beforeAvatarUploadPreview"
                                style={{ display: 'none' }}
                              >
                                <video
                                  className="preview-video"
                                  id="beforeAvatarPreviewVideo"
                                ></video>
                                <div className="preview-info">
                                  <h6 id="beforeAvatarFileName">video.mp4</h6>
                                  <p id="beforeAvatarFileSize">0 MB</p>
                                </div>
                              </div>
                            </div>

                            <div className="upload-actions">
                              <button
                                type="button"
                                id="beforeAvatarUploadBtn"
                                className="btn btn-primary upload-btn before-avatar-video-btns"
                                disabled
                              >
                                <i className="bi bi-upload before-avatar-video-btns"></i> Upload
                                Video
                              </button>

                              <button
                                type="button"
                                id="beforeAvatarPreviewBtn"
                                className="btn btn-primary preview-btn before-avatar-video-btns"
                                style={{ display: 'none' }}
                              >
                                <i className="bi bi-play-circle"></i> Preview Video
                              </button>
                            </div>

                            {/* Progress Section */}
                            <div
                              id="beforeAvatarProgressContainer"
                              className="progress-container"
                              style={{ display: 'none' }}
                            >
                              <div className="progress-header">
                                <span>Uploading...</span>
                                <span id="beforeAvatarProgressPercent">0%</span>
                              </div>
                              <div className="progress-bar-container">
                                <div
                                  id="beforeAvatarProgressBar"
                                  className="progress-bar"
                                  style={{ width: '0%' }}
                                ></div>
                              </div>
                              <p id="beforeAvatarProgressText" className="progress-text">
                                Initializing upload...
                              </p>
                            </div>

                            {/* Uploaded File Info */}
                            <div
                              id="beforeAvatarFileContainer"
                              className="uploaded-file-container"
                              style={{ display: 'none' }}
                            >
                              <div className="uploaded-file-header">
                                <i className="bi bi-check-circle-fill text-success"></i>
                                <span>Video Uploaded Successfully</span>
                              </div>
                              <div className="uploaded-file-info">
                                <a
                                  id="beforeAvatarFileLink"
                                  href="#"
                                  target="_blank"
                                  className="file-link"
                                ></a>
                                <button
                                  type="button"
                                  className="btn btn-primary before-avatar-video-btns"
                                  id="beforeAvatarVideoPreviewButtonFinal"
                                >
                                  <i className="bi bi-eye"></i> Preview
                                </button>
                              </div>
                            </div>
                          </div>

                          <input type="hidden" id="before_avatar_video" />
                        </div>
                      </div>
                    </div>

                    {/* Preview Modal */}
                    <div
                      className="modal fade"
                      id="beforeAvatarVideoPreviewModal"
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="beforeAvatarVideoPreviewModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content">
                          <div className="modal-header" id="before-avatar-video-modal-header">
                            <h5
                              className="modal-title"
                              id="beforeAvatarVideoModalTitle"
                              style={{ color: 'white' }}
                            >
                              <i className="bi bi-play-circle me-2"></i>Before Avatar Video Preview
                            </h5>
                            <a
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                              style={{
                                filter: 'invert(1)',

                                fontSize: '1.4rem',

                                cursor: 'pointer',

                                opacity: '0.9',
                              }}
                            ></a>
                          </div>
                          <div className="modal-body" id="beforeAvatarVideoModalBody">
                            <div className="preview-loading-container">
                              <div className="preview-spinner">
                                <div className="spinner-ring"></div>
                                <div className="spinner-ring"></div>
                                <div className="spinner-ring"></div>
                              </div>
                              <p className="loading-text">Loading video preview...</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Upload Click Sound</label>

                          <div className="audio-upload-container">
                            <div className="upload-area" id="clickSoundUploadArea">
                              <input
                                type="file"
                                id="clickSoundFileInput"
                                accept="audio/*"
                                className="file-input"
                                style={{ height: '100%' }}
                              />
                              <div className="upload-placeholder">
                                <i className="bi bi-cloud-upload"></i>
                                <h5>Drop your audio here or click to browse</h5>
                              </div>
                              <div
                                className="upload-preview"
                                id="clickSoundUploadPreview"
                                style={{ display: 'none' }}
                              >
                                <audio
                                  className="preview-audio"
                                  id="clickSoundPreviewAudio"
                                ></audio>
                                <div className="preview-info">
                                  <h6 id="clickSoundFileName">audio.mp3</h6>
                                  <p id="clickSoundFileSize">0 MB</p>
                                </div>
                              </div>
                            </div>

                            <div className="upload-actions">
                              <button
                                type="button"
                                id="clickSoundUploadBtn"
                                className="btn btn-primary upload-btn click-sound-audio-btns"
                                disabled
                              >
                                <i className="bi bi-upload click-sound-audio-btns"></i> Upload Audio
                              </button>

                              <button
                                type="button"
                                id="clickSoundPreviewBtn"
                                className="btn btn-primary preview-btn click-sound-audio-btns"
                                style={{ display: 'none' }}
                              >
                                <i className="bi bi-play-circle"></i> Preview Audio
                              </button>
                            </div>

                            <div
                              id="clickSoundProgressContainer"
                              className="progress-container"
                              style={{ display: 'none' }}
                            >
                              <div className="progress-header">
                                <span>Uploading...</span>
                                <span id="clickSoundProgressPercent">0%</span>
                              </div>
                              <div className="progress-bar-container">
                                <div
                                  id="clickSoundProgressBar"
                                  className="progress-bar"
                                  style={{ width: '0%' }}
                                ></div>
                              </div>
                              <p id="clickSoundProgressText" className="progress-text">
                                Initializing upload...
                              </p>
                            </div>

                            <div
                              id="clickSoundFileContainer"
                              className="uploaded-file-container"
                              style={{ display: 'none' }}
                            >
                              <div className="uploaded-file-header">
                                <i className="bi bi-check-circle-fill text-success"></i>
                                <span>Audio Uploaded Successfully</span>
                              </div>
                              <div className="uploaded-file-info">
                                <a
                                  id="clickSoundFileLink"
                                  href="#"
                                  target="_blank"
                                  className="file-link"
                                ></a>
                                <button
                                  type="button"
                                  className="btn btn-primary click-sound-audio-btns"
                                  id="clickSoundAudioPreviewButtonFinal"
                                >
                                  <i className="bi bi-eye"></i> Preview
                                </button>
                              </div>
                            </div>
                          </div>

                          <input type="hidden" id="click_sound_audio" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Click sound volume <strong>(The volume range should be 0 to 1)</strong>:
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id='click_sound_volume'
                            min="0"
                            max="1"
                            step="0.1"

                          />
                        </div>
                      </div>
                    </div>



                    <div
                      className="modal fade"
                      id="clickSoundAudioPreviewModal"
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="clickSoundAudioPreviewModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content">
                          <div className="modal-header" id="click-sound-audio-modal-header">
                            <h5
                              className="modal-title"
                              id="clickSoundAudioModalTitle"
                              style={{ color: 'white' }}
                            >
                              <i className="bi bi-play-circle me-2"></i>Click Sound Audio Preview
                            </h5>
                            <a
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                              style={{
                                filter: 'invert(1)',
                                fontSize: '1.4rem',
                                cursor: 'pointer',
                                opacity: '0.9',
                              }}
                            ></a>
                          </div>
                          <div className="modal-body" id="clickSoundAudioModalBody">
                            <div className="preview-loading-container">
                              <div className="preview-spinner">
                                <div className="spinner-ring"></div>
                                <div className="spinner-ring"></div>
                                <div className="spinner-ring"></div>
                              </div>
                              <p className="loading-text">Loading audio preview...</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>


                  <div className="menu-card-ai">
                    <h2 style={{ marginBottom: '10px' }}>On Screen Bubble Manager</h2>
                    <p className='text-muted text-xl'>Note: Please create Bubbles After Creating the AI Form</p>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <div className="bubble-main-header" style={{ background: '#142127' }}>
                            <div className="d-flex align-items-center">
                              Bubble Time Configuration
                            </div>
                          </div>

                          <div>
                            <div className="row">
                              <div className="col-md-4">
                                <div className="form-group interval">
                                  <label>Bubble Time Interval</label>
                                  <input
                                    type="number"
                                    className="form-control form-input-bubble bubble-time-interval"
                                    name="interval"
                                    id="interval"
                                    placeholder="10"
                                  />

                                  <p className='text-muted'>Note: It is the time gap between bubbles</p>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Initial Delay</label>
                                  <input
                                    type="number"
                                    className="form-control initial-delay form-input-bubble"
                                    name="initial_delay"
                                    id="initial_delay"
                                    placeholder="5"
                                  />

                                  <p className='text-muted'>Note: It is the Delay Time of Bubble on Page Load</p>
                                </div>
                              </div>

                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Bubble Display Time </label>
                                  <input
                                    type="number"
                                    className="form-control bubble_time form-input-bubble"
                                    name="bubble_display_time"
                                    id="bubble_display_time"
                                    placeholder="5"
                                    min='5'
                                  />

                                  <p className='text-muted'>Note: Display Time Should be greater than 0</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <div
                            id="bubbleContainer"
                            style={{ maxHeight: '100vh', overflow: 'auto' }}
                          ></div>
                          <a
                            type="button"
                            className="btn btn-primary mt-3"
                            id="bubbleAddBtn"
                            style={{ color: 'white', border: 'none' }}
                          >
                            + Add New Bubble
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>


                  {/*  */}

                  <div className="menu-card-ai">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor="avtar_welcome_text">Avatar Welcome Text:</label>
                          <textarea
                            id="avtar_welcome_text"
                            className="form-control"
                            name="avtar_welcome_text"
                            rows="4"
                            cols="50"
                            style={{ display: 'none' }}
                          ></textarea>
                          <div id="avtarWelcomeContainer"></div>
                          <a
                            id="avtarWelcomeContainerBtn"
                            className=" btn mt-2 dynamic-button "
                            style={{ color: 'white' }}
                          >
                            + Add More
                          </a>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor="speech_time_limit">
                            Recording stops after (Seconds) :
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="speech_time_limit"
                            name="speech_time_limit"
                          />
                        </div>
                      </div>
                    </div>

                    <div className='row'>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor="blank_space">
                            Blank audio time system assumes user has finished speaking (Seconds):
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="blank_space"
                            name="blank_space"
                          />
                        </div>
                      </div>
                    </div>

                    <div className='row'>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor="promo_time_limit">
                            Time between promo messages (Min) (Enter 0 for disable):
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="promo_time_limit"
                            name="promo_time_limit"
                          />
                        </div>
                      </div>
                    </div>


                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor="promo_message">Promo Messages</label>
                          <textarea
                            id="promo_message"
                            className="form-control"
                            name="promo_message"
                            rows="4"
                            cols="50"
                            style={{ display: 'none' }}
                          ></textarea>

                          <div id="promoContainer"></div>
                          <a
                            id="promoContainerBtn"
                            className=" btn mt-2 dynamic-button "
                            style={{ color: 'white' }}
                          >
                            + Add More
                          </a>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor="before_response_text">
                            System responses while waiting for LLM to return response
                          </label>
                          <textarea
                            id="before_response_text"
                            className="form-control"
                            name="before_response_text"
                            rows="4"
                            cols="50"
                            style={{ display: 'none' }}
                          ></textarea>

                          <div id="beforeResponseContainer"></div>
                          <a
                            id="beforeResponseContainerBtn"
                            className=" btn mt-2 dynamic-button"
                            style={{ color: 'white' }}
                          >
                            + Add More
                          </a>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor="user_not_speak_text">
                            System prompts to the user if user does not speak
                          </label>
                          <textarea
                            id="user_not_speak_text"
                            className="form-control"
                            name="user_not_speak_text"
                            rows="4"
                            cols="50"
                            style={{ display: 'none' }}
                          // value={translationData.before_response_text || ''}
                          // onChange={(e) => setTranslationData({ ...translationData, before_response_text: e.target.value })}
                          ></textarea>

                          <div id="userNotSpeakContainer"></div>
                          <a
                            id="userNotSpeakContainerBtn"
                            className=" btn mt-2 dynamic-button"
                            style={{ color: 'white' }}
                          >
                            + Add More
                          </a>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor="google_speech_error">
                            Response to user if error occurs
                          </label>
                          <textarea
                            id="google_speech_error"
                            className="form-control"
                            name="google_speech_error"
                            rows="4"
                            cols="50"
                          // value={translationData.before_response_text || ''}
                          // onChange={(e) => setTranslationData({ ...translationData, before_response_text: e.target.value })}
                          ></textarea>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor="text_replace">
                            Enter A Replacement Text
                          </label>
                          <textarea
                            id="text_replace"
                            className="form-control"
                            name="text_replace"
                            rows="4"
                            cols="50"
                            style={{ display: 'none' }}
                          ></textarea>

                          <div id="textReplaceContainer"></div>
                          <a
                            id="textReplaceContainerBtn"
                            className="btn  mt-2 dynamic-button"
                            style={{ color: 'white' }}
                          >
                            + Add More
                          </a>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor="button_select_message">Button Select Message</label>

                          <div className="form-group custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="isButtonSelectMsgOn"
                              name="isButtonSelectMsgOn"
                              value=""
                            />
                            <label className="custom-control-label" htmlFor="isButtonSelectMsgOn">
                              Enable Button Select Message
                            </label>
                          </div>

                          <textarea
                            id="button_select_message"
                            className="form-control"
                            name="button_select_message"
                            rows="4"
                            cols="50"
                            style={{ display: 'none' }}
                          ></textarea>

                          <div id="buttonSelectMessageContainer"></div>
                          <a
                            id="buttonSelectMessageContainerBtn"
                            className=" btn mt-2 dynamic-button"
                            style={{ color: 'white' }}
                          >
                            + Add More
                          </a>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor="user_mic_random_message">
                            System response if the user inputs 2 words or less
                          </label>

                          <div className="form-group custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="isTwoWordsEnabled"
                              name="isTwoWordsEnabled"
                              value=""
                            />
                            <label className="custom-control-label" htmlFor="isTwoWordsEnabled">
                              Enable System response if the user inputs 2 words or less
                            </label>
                          </div>

                          <textarea
                            id="user_mic_random_message"
                            className="form-control"
                            name="user_mic_random_message"
                            rows="4"
                            cols="50"
                            style={{ display: 'none' }}
                          ></textarea>

                          <div id="userMicRandomMessageContainer"></div>
                          <a
                            id="userMicRandomMessageContainerBtn"
                            className=" btn mt-2 dynamic-button"
                            style={{ color: 'white' }}
                          >
                            + Add More
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/*  */}
                </section>

                {/* <!-- Step 3 --> */}
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Avatar Preview Modal */}
      <div
        className="modal fade"
        id="avatarPreviewModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="avatarPreviewModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header" id="avatar-modal-header">
              <h5 className="modal-title" id="avatarModalTitle" style={{ color: 'white' }}>
                <i className="bi bi-person-circle me-2"></i>Avatar Preview
              </h5>
              <a
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="avatar-modal-close-btn"
                style={{
                  filter: 'invert(1)',
                  fontSize: '1.4rem',
                  cursor: 'pointer',
                  opacity: '0.9',
                }}
              ></a>
            </div>
            <div className="modal-body" id="avatarModalBody"></div>
            {/* <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                <i className="bi bi-x-circle me-2"></i>Close
              </button>
            </div> */}
          </div>
        </div>
      </div>

      {/* Avatar Video Preview Modal */}

      <div

        className="modal fade"

        id="avatarVideoPreviewModal"

        tabIndex="-1"

        role="dialog"

        aria-labelledby="avatarVideoPreviewModalLabel"

        aria-hidden="true"

      >

        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">

          <div className="modal-content">

            <div className="modal-header" id="avatar-video-modal-header">

              <h5 className="modal-title" id="avatarVideoModalTitle" style={{ color: 'white' }}>

                <i className="bi bi-play-circle me-2"></i>Avatar Video Preview

              </h5>

              <a

                className="btn-close"

                data-bs-dismiss="modal"

                aria-label="Close"

                id="avatar-video-modal-close-btn"

                style={{

                  filter: 'invert(1)',

                  fontSize: '1.4rem',

                  cursor: 'pointer',

                  opacity: '0.9',

                }}

              ></a>

            </div>

            <div className="modal-body" id="avatarVideoModalBody"></div>

          </div>

        </div>

      </div>

      {/* Voice Preview Modal */}
      <div
        className="modal fade"
        id="voicePreviewModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="voicePreviewModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header" id="voice-modal-header">
              <h5 className="modal-title" id="voiceModalTitle" style={{ color: 'white' }}>
                <i className="bi bi-mic-fill me-2"></i>Voice Preview
              </h5>
              <a
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="voice-modal-close-btn"
                style={{
                  filter: 'invert(1)',
                  fontSize: '1.4rem',
                  cursor: 'pointer',
                  opacity: '0.9',
                }}
              ></a>
            </div>
            <div className="modal-body" id="voiceModalBody"></div>
            {/* <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                <i className="bi bi-x-circle me-2"></i>Close
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
